export class CaseNoteEditModel{
    
    caseId:number;    
    officeId:number;
    title: string;
    description: string;
    noteDate: string;
}